import { useEffect, useState, Fragment } from "react";
import {
  DashboardIoTGuageC,
  DashboardIoTOneShot,
  DashboardIoTExtreme,
  DashboardIoTExtremeWide,
} from "Components/Dashboard/Components/DashboardIoT_guage";
import { Card, Select, Col, Row, Form, Empty, Spin, Alert } from "antd";
import styles from "../dashboard.module.scss";
import service from "Utility/Service";
import { useAppSelector } from "store/hook";
import { useTranslation } from "react-i18next";
import { TimestampToDate } from "Utility/Fetch";
import { useDeviceIot } from "../queries";
import { useCustomerInf } from "Components/Management/queries";

const { Option } = Select;

const DashboardIoTC = () => {
  const [form] = Form.useForm();
  const { stateCid, loginCid, level, isLogin, time_zone } = useAppSelector((state) => state.global);
  // const [loading, setLoading] = useState(false);
  const [deviceList, setDeviceList] = useState<any | undefined>(undefined);
  const [iotList, setIotList] = useState<any | undefined>(undefined);
  const [currentDisplay, setCurrentDisplay] = useState<any | undefined>(undefined);
  const [iotData, setIotData] = useState<any | undefined>(undefined);
  const [option, setOption] = useState<any | undefined>([]);
  const { data: deviceIotData, isLoading: loading } = useDeviceIot(level, stateCid, loginCid, isLogin);
  const { data: customerInf, isLoading: customerInfLoading } = useCustomerInf(level, stateCid, loginCid);
  const { t } = useTranslation();

  // 取得 customer 後 4 位字符，並轉換為小寫
  const customer_iot =
    level === "super_super" && stateCid === ""
      ? false
      : customerInf?.response?.[0]?.inf_list?.company?.slice(-4)?.toLowerCase() === "_iot";

  useEffect(() => {
    form.resetFields(["id"]);
    setOption(undefined);
  }, [stateCid]);

  useEffect(() => {
    // 有 iot 的設備列表 deviceList
    let device_options: any = [];
    let iot_list: any = [];
    const list = deviceIotData?.device_iot?.filter((item: any) => {
      if (item.obj.iot?.[0]) {
        item.obj.iot?.map((ele: any) => {
          device_options.push([item.nodeInf.id, ele.id]);
          ele.nodeInf_id = item.nodeInf.id;
          ele.time_string = ele.timestamp && TimestampToDate(ele.timestamp * 1000, time_zone, true);
          iot_list.push(ele);
          return ele;
        });
      }
      return item.obj.iot?.[0];
    });

    setIotData(list);
    setIotList(iot_list);
  }, [deviceIotData, stateCid]);

  const handleChange = (value: any) => {
    value = value.split(",");
    setOption(value);
    const name = value[2] === "" ? value[0] : `${value[0]} (${value[2]})`;
    form.setFieldsValue({ id: name });
  };
  return (
    <Card bordered={false} loading={loading}>
      <Form layout="horizontal" form={form}>
        <div className="formwrap">
          <Form.Item name={"id"}>
            <Select onChange={handleChange} optionLabelProp="label" placeholder="Select Device">
              {iotData?.length &&
                iotData.map((item: any, index: number) => {
                  return item.obj.iot.map((iot: any, iot_index: number) => {
                    return (
                      <Select.Option
                        key={`${index} + ${iot_index}`}
                        // @ts-ignore
                        // value 加上 "" 才能顯示 lable 的值
                        value={[item.nodeInf.id, iot.id, iot.name || "", index, iot_index] + ""}
                        // value={[index, iot_index] + ""}
                        label={`${item.nodeInf.id} (${iot.name})`}
                      >
                        {`${item.nodeInf.name !== "" ? item.nodeInf.name : item.nodeInf.id}_${iot.id}_${iot.name}`}
                      </Select.Option>
                    );
                  });
                })}
            </Select>
          </Form.Item>
        </div>
      </Form>

      {option && iotList?.[0]?.data ? (
        iotList?.map((item: any) => {
          if (item.nodeInf_id === option[0] && item.id === option[1]) {
            return (
              <>
                <Row gutter={24} style={{ margin: 20 }}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {t("ISMS.Id")}: {`${item.id}` || ""}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {t("ISMS.name")}: {`${item.name}` || ""}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {t("ISMS.Date")}: {`${!item.time_string ? "null" : item.time_string}`}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {t("ISMS.Data")}: {!JSON.stringify(item.data) ? "null" : JSON.stringify(item.data)}
                  </Col>
                </Row>
              </>
            );
          } else {
            return;
          }
        })
      ) : loading ? (
        <Spin tip="Loading..." style={{ height: "60vh" }}>
          <Alert
            message="Getting Data"
            description="We are now getting data from server, please wait for a few seconds"
          />
        </Spin>
      ) : (
        <div style={{ height: "70vh" }} className={styles.emptyBox}>
          <Empty description={<span>No Data</span>} />
        </div>
      )}

      {option &&
        customer_iot &&
        iotList?.map((item: any) => {
          if (item.nodeInf_id === option[0] && item.id === option[1]) {
            return (
              <Row gutter={24} style={{ marginBottom: 20 }}>
                <Col xs={24} sm={12} md={12} lg={8} className={styles.col_custom_use}>
                  <DashboardIoTGuageC
                    max={50}
                    min={0}
                    c1={0.3}
                    c2={0.5}
                    c3={0.7}
                    c4={1}
                    title={"Temperature"}
                    GuageName={"Temperature"}
                    // value={currentDisplay.data?.controller?.battery?.temperature_c}
                    value={item.data?.Temperature}
                    unit={"℃"}
                  />
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} className={styles.col_custom_use}>
                  <DashboardIoTGuageC
                    max={100}
                    min={0}
                    c1={0.25}
                    c2={0.5}
                    c3={0.75}
                    c4={1}
                    title={"Humidity"}
                    GuageName={"Humidity"}
                    // value={currentDisplay.data?.controller?.battery?.soc_percentage}
                    value={item.data?.Humidity}
                    unit={"%"}
                  />
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} className={styles.col_custom_use}>
                  <DashboardIoTGuageC
                    max={14}
                    min={0}
                    c1={0.25}
                    c2={0.5}
                    c3={0.75}
                    c4={1}
                    title={"pH"}
                    GuageName={"pH"}
                    // value={currentDisplay.data?.controller?.battery?.full_charged_time}
                    value={item.data?.pH}
                    unit={""}
                  />
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} className={styles.col_custom_use}>
                  <DashboardIoTExtreme
                    max={54}
                    min={0}
                    title={"Voltage"}
                    GuageName={"Voltage"}
                    // value={currentDisplay.data?.controller?.load_on_off}
                    value={item.data?.Voltage}
                    unit={"VDC"}
                  />
                </Col>
                <Col xs={24} sm={12} md={12} lg={8} className={styles.col_custom_use}>
                  <DashboardIoTExtremeWide
                    max={10000}
                    min={0}
                    title={"Fan Speed"}
                    GuageName={"Fan Speed"}
                    // value={currentDisplay.data?.controller?.load_on_off}
                    c1={0.2}
                    c2={0.5}
                    c3={0.8}
                    c4={1}
                    value={item.data?.Fan_Speed}
                    unit={"RPM"}
                  />
                </Col>
              </Row>
            );
          } else {
            return;
          }
        })}

      {currentDisplay && (
        <Row gutter={24} style={{ marginBottom: 20 }}>
          {/* <Col xs={24} sm={12} md={8} lg={6} className={styles.col}>
            {currentDisplay?.[0].data?.d3 && (
              <DashboardIoTExtreme
                max={1280}
                min={0}
                title={"Battery"}
                GuageName={"Charge_Max_Wat"}
                value={100}
                unit={"W"}
              />
            )} */}
          {/* <Fragment>
              <DashboardIoTGuageC
                max={100}
                min={0}
                c1={0.2}
                c2={0.5}
                c3={0.7}
                c4={1}
                title={"Battery"}
                GuageName={"SOC"}
                // value={currentDisplay?.data?.controller?.battery?.soc_percentage || 0}
                value={0}
                unit={"%"}
              />
              <DashboardIoTGuageC
                max={10}
                min={0}
                c1={0.2}
                c2={0.5}
                c3={0.8}
                c4={1}
                title={"Battery"}
                GuageName={"Full Charge Time"}
                // value={currentDisplay?.data?.controller?.battery?.full_charged_time || 0}
                value={currentDisplay?.[0].data?.d2 || 0}
                unit={"H"}
              />
              <DashboardIoTExtreme
                max={35}
                min={0}
                title={"Battery"}
                GuageName={"Charge Max Current"}
                // value={currentDisplay?.data?.controller?.today?.charge?.max_current_a || 0}
                value={currentDisplay?.[0].data?.d3 || 0}
                unit={"A"}
              />
              <DashboardIoTExtreme
                max={100}
                min={0}
                title={"Battery"}
                GuageName={"Discharge Max Current"}
                // value={currentDisplay?.data?.controller?.today?.discharge?.max_current_a || 0}
                value={currentDisplay?.[0].data?.d4 || 0}
                unit={"A"}
              />
              <DashboardIoTGuageC
                max={33}
                min={0}
                c1={0.193939394}
                c2={0.484848484848485}
                c3={0.775757575757576}
                c4={1}
                title={"Battery"}
                GuageName={"Over Discharge Time"}
                // value={currentDisplay?.data?.controller?.battery?.over_discharged_time || 0}
                value={currentDisplay?.[0].data?.d5 || 0}
                unit={"H"}
              />
              <DashboardIoTGuageC
                max={0}
                min={55}
                c1={0.181818181818182}
                c2={0.545454545454546}
                c3={0.727272727272728}
                c4={1}
                title={"Battery"}
                GuageName={"Temperature"}
                // value={currentDisplay?.data?.controller?.battery?.temperature_c || 0}
                value={currentDisplay?.[0].data?.d6 || 0}
                unit={"C"}
              />
            </Fragment> */}
          {/* </Col> */}
          {/* <Col xs={24} sm={12} md={8} lg={6} className={styles.col}>
            <DashboardIoTExtreme
              max={5000}
              min={0}
              title={"Battery"}
              GuageName={"Discharge Max Wat"}
              // value={currentDisplay?.data?.controller?.today?.discharge?.max_watt_w || 0}
              value={currentDisplay?.[0].data?.d7 || 0}
              unit={"W"}
            />
            <Fragment>
              <DashboardIoTOneShot
                title={"Battery"}
                GuageName={"Charge Wat"}
                // value={currentDisplay?.data?.controller?.today?.charge?.watt_w || 0}
                value={currentDisplay?.[0].data?.d8 || 0}
                unit={"W"}
              />
              <DashboardIoTOneShot
                title={"Battery"}
                GuageName={"Discharge Wat"}
                // value={currentDisplay?.data?.controller?.today?.discharge?.watt_w || 0}
                value={currentDisplay?.[0].data?.d9 || 0}
                unit={"W"}
              />
              <DashboardIoTGuageC
                max={54}
                min={48}
                c1={0.25}
                c2={0.5}
                c3={0.75}
                c4={1}
                title={"Battery"}
                GuageName={"Voltage"}
                // value={currentDisplay?.data?.controller?.load?.voltage_v || 0}
                value={currentDisplay?.[0].data?.d10 || 0}
                unit={"V"}
              />
              <DashboardIoTExtreme
                max={57.6}
                min={0}
                title={"Battery"}
                GuageName={"Max Voltage"}
                // value={currentDisplay?.data?.controller?.today?.battery?.max_voltage_v || 0}
                value={currentDisplay?.[0].data?.d11 || 0}
                unit={"V"}
              />
              <DashboardIoTGuageC
                max={22}
                min={0}
                c1={0.227272727272727}
                c2={0.454545454545454}
                c3={0.681818181818181}
                c4={1}
                title={"Battery"}
                GuageName={"Charge"}
                // value={currentDisplay?.data?.controller?.battery?.charge_current_a || 0}
                value={currentDisplay?.[0].data?.d12 || 0}
                unit={"A"}
              />
              <DashboardIoTGuageC
                max={200}
                min={0}
                c1={0.2}
                c2={0.5}
                c3={0.8}
                c4={1}
                title={"Battery"}
                GuageName={"Total DisCharge"}
                // value={currentDisplay?.data?.controller?.battery?.total_discharge_ah || 0}
                value={currentDisplay?.[0].data?.d13 || 0}
                unit={"AH"}
              />
            </Fragment>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} className={styles.col}>
            <DashboardIoTOneShot
              title={"Battery"}
              GuageName={"Charge AH"}
              // value={currentDisplay?.data?.controller?.today?.charge?.ampere_hour_ah || 0}
              value={currentDisplay?.[0].data?.d14 || 0}
              unit={"AH"}
            />

            <Fragment>
              <DashboardIoTOneShot
                title={"Battery"}
                GuageName={"Discharge AH"}
                // value={currentDisplay?.data?.controller?.today?.discharge?.ampere_hour_ah || 0}
                value={currentDisplay?.[0].data?.d15 || 0}
                unit={"AH"}
              />
              <DashboardIoTOneShot
                title={"Battery"}
                GuageName={"Charge Total Wat"}
                // value={currentDisplay?.data?.controller?.today?.charge?.total_watt_w || 0}
                value={currentDisplay?.[0].data?.d16 || 0}
                unit={"W"}
              />
              <DashboardIoTGuageC
                max={56.8}
                min={48}
                c1={0.329545454545454}
                c2={0.465909090909091}
                c3={0.625}
                c4={1}
                title={"Battery"}
                GuageName={"Voltage"}
                // value={currentDisplay?.data?.controller?.battery?.voltage_v || 0}
                value={currentDisplay?.[0].data?.d17 || 0}
                unit={"V"}
              />
              <DashboardIoTGuageC
                max={200}
                min={0}
                c1={0.2}
                c2={0.5}
                c3={0.8}
                c4={1}
                title={"Battery"}
                GuageName={"Total Charge"}
                // value={currentDisplay?.data?.controller?.battery?.total_charge_ah || 0}
                value={currentDisplay?.[0].data?.d18 || 0}
                unit={"AH"}
              />

              <DashboardIoTGuageC
                max={1280}
                min={0}
                c1={0.25}
                c2={0.5}
                c3={0.75}
                c4={1}
                title={"Pannel"}
                GuageName={"Wat"}
                // value={currentDisplay?.data?.controller?.solar_pannel?.watt_w || 0}
                value={currentDisplay?.[0].data?.d19 || 0}
                unit={"W"}
              />
              <DashboardIoTGuageC
                max={130}
                min={0}
                c1={0.846153846153846}
                c2={0.884615384615385}
                c3={0.923076923076923}
                c4={1}
                title={"Pannel"}
                GuageName={"Voltage"}
                // value={currentDisplay?.data?.controller?.solar_pannel?.voltage_v || 0}
                value={currentDisplay?.[0].data?.d20 || 0}
                unit={"V"}
              />
            </Fragment>
          </Col>
          <Col xs={24} sm={12} md={8} lg={6} className={styles.col}>
            <DashboardIoTGuageC
              max={20}
              min={0}
              c1={0.25}
              c2={0.5}
              c3={0.75}
              c4={1}
              title={"Pannel"}
              GuageName={"Current"}
              // value={currentDisplay?.data?.controller?.solar_pannel?.current_a || 0}
              value={currentDisplay?.[0].data?.d21 || 0}
              unit={"A"}
            />

            <Fragment>
              <DashboardIoTGuageC
                max={0}
                min={55}
                c1={0.181818181818182}
                c2={0.545454545454546}
                c3={0.727272727272728}
                c4={1}
                title={"Pannel"}
                GuageName={"Temperature"}
                // value={currentDisplay?.data?.controller?.temperature_c || 0}
                value={currentDisplay?.[0].data?.d22 || 0}
                unit={"C"}
              />
              <DashboardIoTExtreme
                max={4}
                min={0}
                title={"Load"}
                GuageName={"ON-OFF"}
                // value={currentDisplay?.data?.controller?.load_on_off || 0}
                value={currentDisplay?.[0].data?.d23 || 0}
                unit={""}
              />
              <DashboardIoTOneShot
                title={"Load"}
                GuageName={"Load-Light"}
                // value={currentDisplay?.data?.controller?.load_light_percentage || 0}
                value={currentDisplay?.[0].data?.d24 || 0}
                unit={"%"}
              />
              <DashboardIoTGuageC
                max={6.4}
                min={0}
                c1={0.25}
                c2={0.5}
                c3={0.75}
                c4={1}
                title={"Load"}
                GuageName={"Current"}
                // value={currentDisplay?.data?.controller?.load?.current_a || 0}
                value={currentDisplay?.[0].data?.d25 || 0}
                unit={"A"}
              />
              <DashboardIoTGuageC
                max={320}
                min={0}
                c1={0.25}
                c2={0.5}
                c3={0.75}
                c4={1}
                title={"Load"}
                GuageName={"Wat"}
                // value={currentDisplay?.data?.controller?.load?.watt_w || 0}
                value={currentDisplay?.[0].data?.d26 || 0}
                unit={"W"}
              />
              <DashboardIoTExtreme
                max={100}
                min={48}
                title={"Battery"}
                GuageName={"Min Voltage"}
                // value={currentDisplay?.data?.controller?.today?.battery?.min_voltage_v || 0}
                value={currentDisplay?.[0].data?.d27 || 0}
                unit={"V"}
              />
            </Fragment>
          </Col> */}
        </Row>
      )}
    </Card>
  );
};
export default DashboardIoTC;
